module.exports = __webpack_public_path__ + "img/112.f488feb5.jpg";